/**
 * @file JobHeaderExtraInfoSlot.tsx
 *
 * @fileoverview This component renders aditional things to the job header. This can be used to add extra fields
 * or any other information relevant to the job information.
 */

import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { Job } from '~/jobiqo/types/types';

interface JobHeaderExtraInfoSlotProps {
  /**
   * The job entity.
   */
  job: Slottable<Job>;
}

export default function JobHeaderExtraInfoSlot({
  job,
}: JobHeaderExtraInfoSlotProps) {
  return null;
}
export { JobHeaderExtraInfoSlot };
